import { useLocalization } from '@/hooks/localization'
import keys from 'lodash/keys'

function useEnumItems (enumDefinition) {
  const { localizeEnum } = useLocalization()
  return keys(enumDefinition.enum).map(key => {
    const value = enumDefinition.enum[key]
    return {
      key,
      value,
      text: localizeEnum(enumDefinition.enumName, value)
    }
  })
}

export {
  useEnumItems
}



// WEBPACK FOOTER //
// ./src/hooks/useEnumItems.js